import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultApi } from '../viewModel/result_api.model';
import { environment } from '../../../environments/environment';
import { BaseService } from './base.service';
import { ICarrinho } from '../../shared/interfaces/carrinho.interface';

@Injectable({
    providedIn: 'root'
})
export class RdService extends BaseService {
    baseUrl = environment.rdBaseUrl;

    constructor(private httpClient: HttpClient) {
        super(httpClient);
    }

    public async updateEventByIdentifier(param): Promise<ResultApi> {
        try {
            return await this.post(param, `platform/conversions?api_key=NiNyIHZJsBTDseftsmQZFRudOPjUEBMyXMeR`);
        } catch (e) {
            return null;
        }
    }

    public async cartPartOne(name: string, mobile: string, email: string, cart: ICarrinho) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho_Site_Passo_1',
                email,
                mobile,
                name,
                cf_email_1: email,
                cf_nome_do_cliente: name,
                cf_celular_pessoal : mobile,
                mobile_phone : mobile,
                cf_plano: cart.categoriaTitulo,
                cf_diarias: cart.countDiarias,
                cf_mensalidade: cart.valorMensal,
                cf_mensalidade_original: cart.valorMensal,
            },
        }
        await this.updateEventByIdentifier(queryRD);
    }

    public async cartPartTwo(cpf: string, dataNascimento: string) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho_Site_Passo_2',
                cf_cpf: cpf,
                cf_data_de_nascimento_0: dataNascimento
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async carrinhoPasso1(
        email: string,
        // utmParams: UtmParams,
        carrinho: any
    ) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho_Site_Passo_1',
                email,
                cf_email_1: email,
                cf_plano: carrinho.categoriaTitulo,
                cf_diarias: carrinho.countDiarias,
                cf_mensalidade: carrinho.valorMensal,
                // cf_mensalidade_desconto: carrinho.valorMensalidadeDesconto,
                cf_mensalidade_original: carrinho.valorMensalidade,
                // utm_campaign: utmParams.utm_campaign,
                // utm_medium: utmParams.utm_medium,
                // utm_source: utmParams.utm_source,
                // utm_term: utmParams.utm_term
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async carrinhoPasso2(email, nome, celular, cpf, dataNascimento) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho_Site_Passo_2',
                email,
                cf_email_2: email,
                cf_nome_do_cliente: nome,
                name: nome,
                cf_celular_pessoal : celular,
                mobile_phone : celular,
                cf_cpf: cpf,
                cf_data_de_nascimento_0: dataNascimento
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async carrinhoPasso3(email, nomeTitular, numeroCartao, dataVencimentoCartao, bairro, cep, complemento, endereco, numero) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho_Site_Passo_3',
                email,
                cf_bairro: bairro,
                cf_cep: cep,
                cf_complemento: complemento,
                cf_endereco: endereco,
                cf_numero: numero,
                cf_tipobanco: 'Cartao de Crédito',
                cf_numero_do_cartao_de_credito: numeroCartao,
                cf_nome_do_titular_do_cartao: nomeTitular,
                cf_data_de_vencimento_do_cartao_de_credito: dataVencimentoCartao
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async carrinhoSucessoCompra(
        email,
        // renda,
        // tipoCargo
    ) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Sucesso_Compra',
                email,
                // cf_renda_aproximada: renda.toString(),
                // cf_tipo_cargo: tipoCargo
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async carrinhoLogin(email) {
        const queryRD = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: {
                conversion_identifier: 'Carrinho login (0 leads) - Login de Clientes',
                email,
            }
        };
        await this.updateEventByIdentifier(queryRD);
    }

    public async getHttpOptions() {
        const headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
            'Access-Control-Allow-Headers':
            // tslint:disable-next-line:max-line-length
            'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
        };

        return {
            headers: new HttpHeaders(headers)
        };
    }

    private async post(param, path): Promise<ResultApi> {
        try {
            const httpOptions =  await this.getHttpOptions();

            return this.httpClient
                .post<any>(`${this.baseUrl}/${path}`, param, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }
}
